import { createAsyncThunk } from '@reduxjs/toolkit'
import moment from 'moment'
import { fetchApi } from '../../services/fetch'
import { printLogs } from '../../utils'
import { endPoints } from '../../services/endPoints'

export const loginAction = createAsyncThunk('auth/login', async (payload, { rejectWithValue }) => {
    const data = {
        "message": "",
        "loginID": payload.email,
        "password": payload.password
    }
    const loginData = {
        endPoint: "User/login",
        value: JSON.stringify(data),
        type: "POST",
        headers: {
            "Content-Type": "application/json-patch+json"
        }
    }
    const response = await fetchApi(loginData);
    if (response.responseCode == 200 && response?.json.Message == "") return response?.json
    else { rejectWithValue(false); return false }
})

export const checkUserAction = createAsyncThunk('auth/checkUser', async (payload, { rejectWithValue }) => {
    const userData = {
        endPoint: "User/getUserByEmail/" + payload.email,
        type: "GET",
        headers: {
            "Content-Type": "application/json-patch+json"
        }
    }
    const response = await fetchApi(userData);
    if (response.responseCode == 200 && response?.json.Message == "") return response?.json
    else { rejectWithValue(false); return false }
})


export const checkRecaptcha = (recaptchaResponse) => {
    return fetch("http://localhost:8080/recaptcha", {
        method: "POST",
        body: JSON.stringify({
            token: recaptchaResponse
        }),
        headers: {
            "Content-type": "application/json"
        },
    })
        .then((res) => res.json())
        .then((resJson) => resJson)
        .catch((err) => err)
}

export const verifyUserAction = createAsyncThunk('auth/verify', async (payload, { rejectWithValue }) => {
    const verifyData = {
        endPoint: endPoints.verify,
        type: "GET",
        headers: {
            "Content-Type": "application/json-patch+json",
            "Authorization": "Bearer " + payload.token
        }
    }
    const response = await fetchApi(verifyData);
    if (response.responseCode == 200 && response?.json.Message == "") return response?.json
    else { rejectWithValue(false); return false }
})

export const isUserAuthorizedAction = createAsyncThunk('auth/isUserAuthorized', async (payload, { rejectWithValue }) => {
    const verifyData = {
        endPoint: endPoints.isAuthorized + "email=" + payload.email,
        type: "POST",
        value: JSON.stringify({ email: payload.email }),
        headers: {
            "Content-Type": "application/json-patch+json",
            "Authorization": "Bearer " + payload.token
        }
    }
    const response = await fetchApi(verifyData);
    if (response.responseCode == 200) return response.json
    else { rejectWithValue(false); return false }
})


export const isUserHasFullAccessAction = createAsyncThunk('auth/isUserHasFullAccess', async (payload, { rejectWithValue }) => {
    const verifyData = {
        endPoint: endPoints.isFullAccess + "email=" + payload.email,
        type: "POST",
        value: JSON.stringify({ email: payload.email }),
        headers: {
            "Content-Type": "application/json-patch+json",
            "Authorization": "Bearer " + payload.token
        }
    }
    const response = await fetchApi(verifyData);
    if (response.responseCode == 200) return response.json
    else { rejectWithValue(false); return false }
})
